import { render } from "./RacquetSportsResults.vue?vue&type=template&id=0f85740d&scoped=true"
import script from "./RacquetSportsResults.vue?vue&type=script&lang=js"
export * from "./RacquetSportsResults.vue?vue&type=script&lang=js"

import "./RacquetSportsResults.vue?vue&type=style&index=0&id=0f85740d&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f85740d"]])

export default __exports__